import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetAllItemsAPI } from "../../ApiRequests";

const branch = JSON.parse(localStorage.getItem("user"))?.branch_number;

export const fetchProducts = createAsyncThunk("fetch/Items", async () => {
  try {
    const response = await GetAllItemsAPI();

    return response?.data?.data.payload;
  } catch (error) {
    console.log(error);
  }
  return [];
});

const ProductSlice = createSlice({
  name: "Items",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProducts.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchProducts.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchProducts.rejected, (state, action) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default ProductSlice.reducer;
